<template>
	<div>
		<v-row class="my-3">
			<v-col cols="2" sm="2" md="1" lg="1" xl="1" class="py-1">
				<h4>Item</h4>
				<span>{{ itemSelecionado.item }}</span>
			</v-col>
			<v-col cols="3" sm="2" md="2" lg="2" xl="2" class="py-1">
				<h4>Tipo</h4>
				<span>{{ itemSelecionado.tipo }}</span>
			</v-col>
			<v-col cols="7" sm="8" md="8" lg="8" xl="8" class="py-1">
				<h4>Descrição</h4>
				<texto-tooltip :texto="itemSelecionado.descricao" :tamanho-maximo="textoTamanhoMaximo"></texto-tooltip>
			</v-col>
		</v-row>

		<v-divider></v-divider>

		<div class="my-3">
			<v-row>
				<v-col cols="12" sm="6">
					<label-personalizado
						nome-campo="Fornecedor Atual"
						:obrigatorioPorPadrao="true"
					></label-personalizado>
					<v-combobox
						:disabled="true"
						:rules="regrasFornecedorAtual"
						placeholder="Selecione o Fornecedor"
						:items="fornecedores"
						item-text="razaoSocial"
						v-model="idFornecedorAtual"
						clearable
					></v-combobox>
				</v-col>
				<v-col cols="12" sm="6">
					<label-personalizado
						nome-campo="Novo Fornecedor"
						:obrigatorioPorPadrao="true"
					></label-personalizado>
					<v-combobox
						:disabled="!idFornecedorAtual"
						:rules="regrasFornecedorNovo"
						placeholder="Selecione o Fornecedor"
						:items="filiais"
						item-text="razaoSocial"
						item-value="id"
						v-model="idFilial"
						clearable
					>
						<template #no-data class="pa-0">
							<p class="ml-3 mt-3 text-center texto-fornecedor-nao-encontrado">
								Não possui fornecedores por aqui
							</p>
						</template>
					</v-combobox>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="12" lg="12" xl="12" class="py-0">
					<label-personalizado nome-campo="Motivo" :obrigatorioPorPadrao="true"></label-personalizado>
					<v-container class="transparent" fluid>
						<v-textarea
							:rules="regrasJustificativa"
							v-model="alterarFornecedor.justificativa"
							placeholder="Informe o motivo"
							rows="2"
							counter="300"
							class="ma-0 py-0"
						></v-textarea>
					</v-container>
				</v-col>
			</v-row>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { actionTypes, mutationTypes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'

export default {
	name: 'alterar-fornecedor',
	mixins: [validacaoFormulario],
	data() {
		return {
			regrasJustificativa: [
				(value) => this.regraObrigatoriedade(value, 'A justificativa é obrigatória.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						300,
						'O campo de motivo deve ser igual ou menor que 300 caracteres!',
					),
			],
			regrasFornecedorAtual: [(value) => !!value || 'O campo do Fornecedor atual deve ser preenchido!'],
			regrasFornecedorNovo: [(value) => !!value || 'O campo do Novo Fornecedor deve ser preenchido!'],
			idFornecedorAtual: null,
			idFilial: null,
			fornecedores: [],
			filiais: [],
			textoTamanhoMaximo: 250,
		}
	},
	computed: {
		...mapState({
			alterarFornecedor: (state) => state.itemAta.alterarFornecedor.alterar,
			itemSelecionado: (state) => state.itemAta.itemSelecionado,
		}),
	},
	watch: {
		idFornecedorAtual: {
			handler(novoValor) {
				if (novoValor !== null) {
					this.alterarFornecedor.idFornecedor = novoValor.id
					this.buscarFiliais(novoValor.idPessoa)
				}
				this.filiais = []
				this.idFilial = null
			},
			deep: true,
		},
		idFilial: {
			handler(novoValor) {
				if (novoValor !== null) {
					this.alterarFornecedor.idPessoaNova = novoValor.id
				}
			},
			deep: true,
		},
	},
	async mounted() {
		this.alterarFornecedor.idAtaItem = this.itemSelecionado.id
		await this.buscarFornecedores()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_FORNECEDOR.ALTERAR.RESET_ALTERAR_FORNCEDORES)
	},
	methods: {
		async buscarFornecedores() {
			const { itens } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.ALTERAR_FORNECEDOR.ALTERAR.BUSCAR_FORNECEDORES,
				this.itemSelecionado.id,
			)
			this.fornecedores = itens
			if (itens.length > 0) this.idFornecedorAtual = itens[0]
		},
		async buscarFiliais(idFornecedor) {
			const { itens } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.ALTERAR_FORNECEDOR.ALTERAR.BUSCAR_FILIAIS,
				idFornecedor,
			)
			this.filiais = itens
		},
	},
}
</script>

<style lang="stylus" scoped>
.texto-fornecedor-nao-encontrado
	font-size: 13px !important
	color: #888 !important;
</style>
